export function applyDiscount(price, percent) {
  return Math.round(price * (1 - percent / 100));
}

// For the care-plan slot: 'percent' | 'free' | 'custom' | 'none'.
export function applyCarePlanMode(price, mode, percent, custom) {
  switch (mode) {
    case 'percent': return applyDiscount(price, percent);
    case 'free': return 0;
    case 'custom': return custom;
    default: return price;
  }
}
